export enum AdminUserType {
  superAdmin = "superAdmin",
  regular = "regular",
}

export interface Me {
  _id: string;
  type: AdminUserType;
  email: string;
}
